import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { Container, Navbar, Nav, Stack, NavDropdown } from "react-bootstrap";
import LoginButton from "./LoginButton";
import LoggedIn from "./LoggedIn";
import AuthContext from "../../context/AuthContext";
import LanguageSelector from "./LanguageSelector";
const MyNav = () => {
    const { user, loading } = useContext(AuthContext);
    const { t } = useTranslation(["common"]);
    return (
        <Navbar
            collapseOnSelect
            expand="lg"
            bg="dark"
            data-bs-theme="dark"
            id="UniversalTopNavBar"
        >
            <Container>
                <Navbar.Brand
                    href="/"
                    style={{ pointerEvents: loading ? "none" : "auto" }}
                >
                    <img
                        alt=""
                        src={require("./../../assets/img/logo192.png")}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav
                        activeKey={window.location.pathname}
                        className="me-auto"
                    >
                        {/* <Nav.Link href="/" disabled={loading}>{t("home")}</Nav.Link> */}
                        {/* <Nav.Link href="/query-prompt" disabled={loading}>
                            {t("components.mynav:ai_search_tab")}
                        </Nav.Link> */}
                        <Nav.Link href="/patients" disabled={loading}>
                            {t("components.mynav:patients_tab")}
                        </Nav.Link>
                        <Nav.Link href="/scheduler" disabled={loading}>
                            {t("components.mynav:scheduler_tab")}
                        </Nav.Link>
                        <Nav.Link href="/waitlist" disabled={loading}>
                            {t("components.mynav:waitlist_tab")}
                        </Nav.Link>
                        {/* <Nav.Link href="/study-config" disabled={loading}>
                            {t("misc:study_config")}
                        </Nav.Link> */}
                        {/* <Nav.Link href="/users-feedbacks" disabled={loading}>Feedbacks</Nav.Link> */}
                    </Nav>
                    <Nav>
                        <Stack
                            direction="horizontal"
                            gap={2}
                            className="justify-content-sm-center justify-content-lg-between"
                        >
                            {user?.token && <LoggedIn />}
                            {!user?.token && (
                                <>
                                    <LoginButton />
                                    <LanguageSelector />
                                </>
                            )}
                        </Stack>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default MyNav;
